import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToHash() {

    const location = useLocation();

    useEffect(() => {

        if (location.hash) {

            const el = document.getElementById(location.hash.replace("#", ""));

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: "smooth" });
                }, 100);
            }

        }

    }, [location]);

    return null;
}